export const LAST_NAVTEX_API_URL = "https://mavivatan.net/wp-json/wp/v2/posts?categories=254";
export const DRILL_FLEET_LAST_LOCATIONS_API_URL = "https://mavivatan.net/wp-json/wp/v2/posts?categories=255"
//https://mavivatan.net/wp-json/wp/v2/posts?&categories=254&per_page=5
//per_page=count
//https://mavivatan.net/wp-json/wp/v2/categories


export const DYNAMIC_DATA_TEMPLATE =
{
    "id": "",
    "name": "",
    "menuOrder": 0,
    "menuItemType": "accordion",
    "isUnitedData": false,
    "isChildExist": true,
    "isChildStatic": false,
    "childrenList": [
        {
            "name": "", //menü ismi
            "belongingkey": "bluehomelandNegotiationBorders", //! cocukların ait olduğu global state adresi
            "menuItemType": "basic", //menü item tipi
            "type": "", // data tipi
            "isUnitedData": false,
            "data": "", //data path
            "popupContent": "", //popup varsa içeriği yoksa boş
            "styles": {
                color: '#1f2021',
                weight: 1,
                fillOpacity: 0.6,
                fillColor: '#ff1717',
            }
        }
    ]
}
